import { FC, useState } from "react";
import {
  NavigationMenu,
  NavigationMenuItem,
  NavigationMenuLink,
  NavigationMenuList,
  navigationMenuTriggerStyle,
} from "../../components/ui/navigation-menu";
import Logo from "../Logo/Logo";
import { Button } from "../ui/button";
interface HeaderProps {
  onScrollToContact?: () => void;
  onScrollToAboutUs?: () => void;
}

const Header: FC<HeaderProps> = ({ onScrollToContact, onScrollToAboutUs }) => {
  const [activeItem, setActiveItem] = useState<string>("home");

  return (
    <header className="sticky top-0 z-50 w-full bg-white/95 backdrop-blur-md border-b border-gray-100">
      <div className="max-w-7xl mx-auto px-6 py-4">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <div className="flex-shrink-0">
            <Logo />
          </div>

          {/* Navigation Menu */}
          <nav className="hidden md:block">
            <NavigationMenu>
              <NavigationMenuList className="flex items-center space-x-2">
                <NavigationMenuItem>
                  <NavigationMenuLink
                    className={`px-4 py-2 text-sm font-medium transition-colors duration-300 cursor-pointer ${
                      activeItem === "about" ? "text-[#73c4f2] font-semibold" : "text-gray-700 hover:text-primary"
                    }`}
                    onClick={() => {
                      setActiveItem("about");
                      onScrollToAboutUs?.();
                    }}
                  >
                    Qui sommes nous ?
                  </NavigationMenuLink>
                </NavigationMenuItem>

                <NavigationMenuItem>
                  <NavigationMenuLink
                    className={`px-4 py-2 text-sm font-semibold transition-colors duration-300 ${
                      activeItem === "hydreaulys" ? "text-[#73c4f2]" : "text-gray-700 hover:text-primary"
                    }`}
                    href={process.env.REACT_APP_HYDREAULYS_URL}
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => setActiveItem("hydreaulys")}
                  >
                    HYDREAULYS
                  </NavigationMenuLink>
                </NavigationMenuItem>

                <NavigationMenuItem>
                  <NavigationMenuLink
                    className={`px-4 py-2 text-sm font-semibold transition-colors duration-300 ${
                      activeItem === "aquavesc" ? "text-[#73c4f2]" : "text-gray-700 hover:text-secondary"
                    }`}
                    href={process.env.REACT_APP_AQUAVESC_URL}
                    target="_blank"
                    rel="noreferrer"
                    onClick={() => setActiveItem("aquavesc")}
                  >
                    AQUAVESC
                  </NavigationMenuLink>
                </NavigationMenuItem>

                <NavigationMenuItem>
                  <NavigationMenuLink
                    className={`px-4 py-2 text-sm font-medium transition-colors duration-300 cursor-pointer ${
                      activeItem === "contact" ? "text-[#73c4f2] font-semibold" : "text-gray-700 hover:text-primary"
                    }`}
                    onClick={() => {
                      setActiveItem("contact");
                      onScrollToContact?.();
                    }}
                  >
                    Contact
                  </NavigationMenuLink>
                </NavigationMenuItem>
              </NavigationMenuList>
            </NavigationMenu>
          </nav>

          {/* Élu Button */}
          <div className="flex-shrink-0">
            <a
              href="https://portail.eauxseineouest.fr/DocuWareProxy/sso?returnUrl=/home"
              target="_blank"
              rel="noopener noreferrer"
            >
              <button className="group relative px-6 py-2.5 bg-gradient-to-r from-primary to-primary/90 text-white font-semibold rounded-lg overflow-hidden transition-all duration-300 hover:scale-105 hover:shadow-lg hover:shadow-primary/30">
                {/* Shine effect */}
                <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700"></div>

                {/* Content */}
                <span className="relative flex items-center gap-2">
                  <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
                  </svg>
                  Élu
                </span>
              </button>
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
